export function sanitizeHexColor(color: string | undefined): string | undefined {
  if (!color) return undefined;
  const cleaned = color.replace(/[^0-9A-Fa-f]/g, "");
  if (cleaned.length === 6) return `#${cleaned}`;
  if (cleaned.length === 8) return `#${cleaned}`;
  if (cleaned.length === 3) return `#${cleaned[0]}${cleaned[0]}${cleaned[1]}${cleaned[1]}${cleaned[2]}${cleaned[2]}`;
  return undefined;
}
